<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
<!--    <router-view></router-view>-->
    <ProductDetail/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import ProductDetail from "@/views/home/product_show/productDetail.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    ProductDetail,
    Footer
  },
}
</script>

<style>
</style>